"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLOSE_BUTTON_ALT_TEXT = exports.EXPIRED_FIOC_DESCRIPTION03 = exports.EXPIRED_FIOC_DESCRIPTION02 = exports.EXPIRED_FIOC_DESCRIPTION01 = exports.GO_TO_PROFILE = exports.CANCEL_BUTTON = exports.TITLE = exports.BASE_KEY = void 0;
exports.BASE_KEY = 'mbUpdateDocumentationGoingToExpire';
exports.TITLE = `${exports.BASE_KEY}.modalTitleShort`;
exports.CANCEL_BUTTON = `${exports.BASE_KEY}.modalNavigationUpdateLaterLink`;
exports.GO_TO_PROFILE = `${exports.BASE_KEY}.modalNavigationUploadDocumentationButton`;
exports.EXPIRED_FIOC_DESCRIPTION01 = `${exports.BASE_KEY}.mbModalExpiredKyc.description01`;
exports.EXPIRED_FIOC_DESCRIPTION02 = `${exports.BASE_KEY}.mbModalExpiredKyc.description02`;
exports.EXPIRED_FIOC_DESCRIPTION03 = `${exports.BASE_KEY}.mbModalExpiredKyc.description03`;
exports.CLOSE_BUTTON_ALT_TEXT = `${exports.BASE_KEY}.a11y.mbModalUpdateKyc.crossIcon`;
//# sourceMappingURL=fioc.literals.js.map